import React from 'react';
import axios from 'axios';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow  from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination'
import { withStyles  } from '@material-ui/core/styles'
import _ from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { gerarHtmlPedido } from '../utils/pedido_pdf_util';
import APIUtils, { mensagemErro } from '../utils/api_util';
import toastr from 'toastr';


const TableHistoricoPedidos = (props) => {

    const { classes, statusOptions } = props
    const [pedidoCarregando, setPedidoCarregando] = React.useState(null)
    const [pedidoVisualizacao, setPedidoVisualizacao] = React.useState(null)
    const [visualizacaoCarregada, setVisualizacaoCarregada] = React.useState(false)
    const visualizacaoRef = React.useRef(null)
    const telaPequena = useMediaQuery('(max-width:600px)')

    const origemOptions = [
        "Direto","Web","E-mail","Fone","Fax","Orçamento","Palm","Balcão","Balcão NF"
    ]

    function buscarOrigem(origem){
        return origemOptions.find((_el, key) => key === origem)
    }

    function buscarStatus(status){
        return statusOptions.find((el, key) => key === status)
    }

    async function gerarPdf(pedido) {
        setPedidoCarregando(pedido.id)
        try {
            const response = await axios.get(`${APIUtils.API_URL}/api/v1/pedidos/${pedido.id}/detalhes`)
            setVisualizacaoCarregada(false)
            setPedidoVisualizacao({
                ...pedido,
                ...response.data,
                status: buscarStatus(pedido.status) || pedido.status,
                origem: buscarOrigem(pedido.origem) || pedido.origem,
            })
        } catch (e) {
            toastr.error(`Erro carregando os detalhes do pedido: ${mensagemErro(e)}`)
        } finally {
            setPedidoCarregando(null)
        }
    }

    function imprimirPedido() {
        const janela = visualizacaoRef.current && visualizacaoRef.current.contentWindow
        if (!janela) {
            toastr.error('Não foi possível preparar a impressão do pedido.')
            return
        }

        try {
            janela.focus()
            janela.print()
        } catch (e) {
            toastr.error(`Não foi possível abrir a impressão do pedido: ${mensagemErro(e)}`)
        }
    }

    function renderHeader() {
        return (
            <TableHead  className={ classes.thead }>
                <TableRow className={ classes.tbodyTr }>
                    <TableCell className={ classes.tableCell }>Status</TableCell>
                    <TableCell className={ classes.tableCell }>Origem</TableCell>
                    <TableCell className={ classes.tableCell }>Data</TableCell>
                    <TableCell className={ classes.tableCell }>Número</TableCell>
                    <TableCell className={ classes.tableCell }>Cliente</TableCell>
                    <TableCell className={ classes.tableCell } align='right'>Valor (R$)</TableCell>
                    <TableCell className={ classes.tableCell } align='center'>PDF</TableCell>
                </TableRow>    
            </TableHead>    
        )
    }

    function renderBody() {

        if(!props.historico){
            return null;
        }

        return (
            <TableBody>
                { props.historico.map(pedido => {
                    return (
                        <TableRow key={ pedido.id } className={ classes.tbodyTr }>
                            <TableCell className={ classes.tableCell }>
                                <div className={ classes.status } style={ corStatus(pedido.status) }>
                                    { buscarStatus(pedido.status) }
                                </div>
                            </TableCell>
                            <TableCell className={ classes.tableCell }>{ buscarOrigem(pedido.origem) }</TableCell>
                            <TableCell className={ classes.tableCell }>{ pedido.data }</TableCell>
                            <TableCell className={ classes.tableCell }>{ pedido.id }</TableCell>
                            <TableCell className={ classes.tableCell }>{ pedido.cliente }</TableCell>
                            <TableCell className={ classes.tableCell } align='right'>{ pedido.vlr.toLocaleString('pt-br', {minimumFractionDigits: 2}) }</TableCell>
                            <TableCell className={ classes.tableCell } align='center'>
                                <Tooltip title="Visualizar pedido e imprimir ou salvar em PDF">
                                    <IconButton
                                        aria-label={`Visualizar pedido ${pedido.id}`}
                                        onClick={() => gerarPdf(pedido)}
                                        size="small"
                                        disabled={pedidoCarregando !== null}
                                    >
                                        {pedidoCarregando === pedido.id
                                            ? <CircularProgress size={18} />
                                            : <SearchIcon />}
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                        </TableRow>    
                    )
                })}
            </TableBody>    
        )
    }

    function corStatus(status) {
        if (_.isEqual(status, "Em aberto") || _.isEqual(status, "Em separação") || _.isEqual(status, "Separado") || _.isEqual(status, "Em conferência") || _.isEqual(status, "Conferido")) {
            return { background: '#14d85d' }
        }
        if (_.isEqual(status, "Atendido parcial")) {
            return { background: '#eed800' }
        }
        if (_.isEqual(status, "Atendido")) {
            return { background: '#000' }
        }
        if (_.isEqual(status, "Bloqueado")) {
            return { background: '#d01b1b' }
        }
        if (_.isEqual(status, "Cancelado")) {
            return { background: '#817578' }
        }
        return { background: '#fff', color: '#000' } 
    }

    return (
    <>
        <Paper className={classes.root}>
            <Table>
                {renderHeader()}
                {renderBody()}
                <TablePagination
                    count={props.nroPedidos}
                    labelDisplayedRows={({ from, to, count }) => `${from} - ${to} de ${count}`}
                    component="div"
                    page={props.page}
                    rowsPerPage={20}
                    rowsPerPageOptions={[]}
                    onChangePage={props.changePage}
                    backIconButtonText="Página Anterior"
                    nextIconButtonText="Próxima Página"
                />
            </Table>
        </Paper>
        <Dialog
            open={Boolean(pedidoVisualizacao)}
            onClose={() => setPedidoVisualizacao(null)}
            fullWidth
            maxWidth="lg"
            fullScreen={telaPequena}
            PaperProps={{
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    height: telaPequena ? '100%' : '85vh',
                },
            }}
        >
            <DialogTitle>Pedido {pedidoVisualizacao && pedidoVisualizacao.id}</DialogTitle>
            <DialogContent style={{ padding: 0, flex: 1, overflow: 'hidden' }}>
                {pedidoVisualizacao && (
                    <iframe
                        ref={visualizacaoRef}
                        title={`Prévia do pedido ${pedidoVisualizacao.id}`}
                        srcDoc={gerarHtmlPedido(pedidoVisualizacao)}
                        sandbox="allow-same-origin allow-modals"
                        onLoad={() => setVisualizacaoCarregada(true)}
                        style={{ border: 0, width: '100%', height: '100%' }}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setPedidoVisualizacao(null)}>
                    Fechar
                </Button>
                <Button
                    color="primary"
                    startIcon={<PrintIcon />}
                    onClick={imprimirPedido}
                    disabled={!visualizacaoCarregada}
                >
                    Imprimir / salvar PDF
                </Button>
            </DialogActions>
        </Dialog>
    </>
    )
}

const styles = ({

    root: {
        width: '100%',
        overflowX: 'auto'
    },

    status: {
        textAlign: 'center', 
        color: '#fff', 
        fontSize: '0.75em', 
        fontWeight: 'bold',
        borderRadius: '10px',
        padding: 7
    },

    thead: {
        background: '#ccc'
    },

    theadTr: {
        height: '30px'
    },

    tbodyTr: {
        height: '30px'
    },

    tableCell: {
        padding: '4px 4px 4px 4px',
        '&:last-of-type': { paddingRight: '4px' },
        '& button': { width: 20, height: 20 },
        '& button > span > svg': { fontSize: 18 }
    }            
})

export default withStyles(styles)(TableHistoricoPedidos)